import { render, staticRenderFns } from "./CenteredCard.vue?vue&type=template&id=6ebea122&scoped=true"
import script from "./CenteredCard.vue?vue&type=script&lang=js"
export * from "./CenteredCard.vue?vue&type=script&lang=js"
import style0 from "./CenteredCard.vue?vue&type=style&index=0&id=6ebea122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebea122",
  null
  
)

export default component.exports